import {Component, Inject, OnInit, Optional} from '@angular/core';
import {AppService, StoreSelectorsService} from "../../services";
import {Compbaser} from "../../components/compbaser";
import {IUser} from "../../interfaces";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {Observable} from "rxjs";
import {actionAccountContactRequestDone} from "../../store/actions/user.actions";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NewNodeDialog} from "../../components/category-tree/add-node/add-node.component";
import {isHostDevOrLocal, popupWindow} from "../../common";

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent extends Compbaser implements OnInit {

    m_user: IUser;
    formGroup: FormGroup;
    titleAlert = 'This field is required';
    emailSent = false;
    post: any = '';
    selectedStars = 0;
    unsubscribeMode = false;
    topics = [
        {name: 'feedback', 'value': '[Feedback]  How can we improve digital signage for you?'},
        {name: 'sales', 'value': '[Sales] Would you like to place a new order?'},
        {name: 'support', 'value': '[Support] Got a technical problem?'}
    ];

    protected readonly top = top;

    constructor(@Optional() @Inject(MAT_DIALOG_DATA) data: any,
                @Optional() public dialogRef: MatDialogRef<NewNodeDialog>,
                private formBuilder: FormBuilder,
                private translocoService: TranslocoService,
                private appService: AppService,
                private toastr: ToastrService,
                private storeSelector: StoreSelectorsService) {
        super();
        if (data?.unsubscribe) {
            this.unsubscribeMode = true;
        }
    }

    ngOnInit() {
        this.createForm();
        this.cod(
            this.storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.m_user = user;
                })
        );
    }

    createForm() {
        // 'topic': [0, Validators.required],
        this.formGroup = this.formBuilder.group({
            'email': [null, [Validators.required, Validators.email], this.checkInUseEmail],
            'name': [null, Validators.required],
            'description': [null, [Validators.required, Validators.minLength(10), Validators.maxLength(255)]],
            'feedback': ['']
        });
    }

    get name() {
        return this.formGroup.get('name') as FormControl;
    }

    checkInUseEmail(control) {
        // future support to check server for email contact
        const db = ['jack@torchwood.com'];
        return new Observable(observer => {
            setTimeout(() => {
                const result = (db.indexOf(control.value) !== -1) ? {'alreadyInUse': true} : null;
                observer.next(result);
                observer.complete();
            }, 1000);
        });
    }

    countStar(star) {
        this.selectedStars = star;
    }

    addClass(star) {
        let ab = "";
        for (let i = 0; i < star; i++) {
            ab = "starId" + i;
            document.getElementById(ab).classList.add("selected");
        }
    }

    removeClass(star) {
        let ab = "";
        for (let i = star - 1; i >= this.selectedStars; i--) {
            ab = "starId" + i;
            document.getElementById(ab).classList.remove("selected");
        }
    }


    sendEmail(v) {
        const topic = this.unsubscribeMode ? 'unsubscribe' : 'general question';
        this.emailSent = true;
        const message = `<br/>
            <span style="font-weight: bold">topic: ${topic}</span><br/>
            account: ${this.m_user?.email ? this.m_user?.email : ''}<br/>
            businessName: ${this.m_user?.businessName ? this.m_user?.businessName : ''}<br/>
            enterprise: ${this.m_user?.enterprise ? this.m_user?.enterprise : ''}<br/>
            dashboard: ${this.m_user?.dashboard ? this.m_user?.dashboard : ''}<br/>
            ip address: ${this.m_user?.ip ? this.m_user?.ip : ''}<br/>
            stars: ${this.selectedStars === 0 ? 'none' : this.selectedStars}<br/>            
            <hr/>
            <strong>question: ${this.formGroup.get('description').value} </strong> <br/>
            <hr/>
            <strong>feedback: ${this.formGroup.get('feedback').value} </strong> <br/>
        `;
        this.storeSelector.sendEmail(this.formGroup.get('email').value, message, this.formGroup.get('name').value, false);
        this.toastr.success(this.translocoService.translate('toast.weWillContact2', {}, this.translocoService.getActiveLang()));
        if (this.unsubscribeMode)
            this.dialogRef.close();
    }

    toggleStayInTouch(e, mode) {
        this.storeSelector.dispatch(actionAccountContactRequestDone({mode, errorMessage: null}));
    }

    getErrorEmail() {
        return this.formGroup.get('email').hasError('required') ? 'Field is required' :
            this.formGroup.get('email').hasError('pattern') ? 'Not a valid emailaddress' :
                this.formGroup.get('email').hasError('alreadyInUse') ? 'This emailaddress is already in use' : '';
    }

    getErrorPassword() {
        return this.formGroup.get('password').hasError('required') ? 'Field is required (at least eight characters, one uppercase letter and one number)' :
            this.formGroup.get('password').hasError('requirements') ? 'Password needs to be at least eight characters, one uppercase letter and one number' : '';
    }

    // openChatGPT(e) {
    //     e.preventDefault();
    //     e.stopImmediatePropagation();
    //     const url = `https://secure.digitalsignage.com:8501/`;
    //     const win = popupWindow({url, title: 'Chat GPT for DigitalSignage.com', h: '300', w: '400'});
    // }

    openChatGPT(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let url: string;
        if (isHostDevOrLocal()) {
            url = `https://dev.signage.me/signstudio/shopping-cart/chatbot`;
        } else {
            url = `https://galaxy.signage.me/signstudio/shopping-cart/chatbot`;
        }
        const win = popupWindow({url, title: 'Chat GPT for DigitalSignage.com', h: '300', w: '400'});
    }

    onSubmit(post) {
        this.post = post;
    }
}
